const handleBackInStock = () => {
  $('.js-notify form').on('submit', function(event) {
    const $this = $(this);
    const action = $this.attr('action');
    const $notify = $this.closest('.js-notify');

    // Find Current Variant Id
    const variantId = $('.js-pdp').find('.js-product-main-select option:selected').val();

    $this.find('input[name="variant"]').val(variantId);

    $.ajax({
      url: action,
      method: 'POST',
      data: $this.serialize(),
      success: function(result) {
        if (result.success) {
          // Show Success Message
          $notify.addClass('notify--success');
        };
      }
    });

    event.preventDefault();
  });
}

handleBackInStock();
